
export class LoginResult {
    public access_token = '';
    public end_date = '';
    public expires_in = 0;
    public hashUrl = '';
    public refresh_token = '';
    public scope = '';
    public token_type = '';
}